var map = {
	"./1825238600611532802.png": "8459",
	"./America.png": "6113",
	"./Brazil.png": "ab61",
	"./India.png": "452f",
	"./color1.png": "0da0",
	"./comm_icon_gb.png": "27d8",
	"./h-ac-star.png": "fb0d",
	"./icon_dt_pmd.png": "bdee",
	"./icon_normal_pix.png": "8b77"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "949c";